import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

interface BaseItemSaturationOptionProps {
  saturation: number;
  updateSaturation(saturation: number, undoable?: boolean): void;
}

export function BaseItemSaturationOption({...props}: BaseItemSaturationOptionProps): ReactElement<any> {
  const onChangeHandler = (updatedValue: number): void => {
    props.updateSaturation(updatedValue, false);
  };

  const onChangeEndedHandler = (updatedValue: number): void => {
    props.updateSaturation(updatedValue, true);
  };

  return (
    <ContextualMenuSliderOptions
      id="item-saturation-option"
      value={props.saturation}
      label={window.i18next.t('pmwjs_saturation')}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEndedHandler}
      range={{min: -1, max: 1}}
      transformDisplay={{min: 0, max: 100}}
    />
  );
}
